export default __webpack_public_path__ + "static/media/close.315c29aa.svg";